import { createSlice, configureStore } from "@reduxjs/toolkit";


// 创建子模块（登录信息）
export const loginInfo = createSlice({
    name: 'loginInfo',
    initialState: { // 初始化
        info: {
            name: '张三'
        }
    },
    reducers: { // 整合器
        setInfo(state, action) { 
            state.info = action.payload
        }
    }
})

// 创建store, 合并所有子模块
const store = configureStore({
    reducer: {
        loginInfo: loginInfo.reducer
    }
})

export default store